/**
 * Scene-editor only: show some gameConfig.options fields on other panels
 * without changing their persisted paths.
 */

export const SCENE_EDITOR_RELOCATED_OPTIONS = [
  {
    optionKey: "isEntireScreenCTAEnabled",
    caption: "Entire Screen CTA",
    editorType: "switchGeneric",
    generalSection: "endCard",
  },
  {
    optionKey: "isInGameCTAEnabled",
    caption: "In Game CTA",
    editorType: "switchGeneric",
    componentId: "ctaButton1",
  },
  {
    optionKey: "isSoundEnabled",
    caption: "Sound",
    editorType: "switchGeneric",
    componentKey: "sounds",
  },
  {
    optionKey: "isBannerEnabled",
    caption: "Banner",
    editorType: "switchGeneric",
    componentId: "banner1",
  },
];

export function isOptionRelocatedFromGeneral(optionKey) {
  return SCENE_EDITOR_RELOCATED_OPTIONS.some((entry) => entry.optionKey === optionKey);
}

function componentMatchesRelocation(component, entry) {
  if (!component) return false;
  if (entry.componentId && component.id === entry.componentId) return true;
  if (entry.componentKey && component.key === entry.componentKey) return true;
  return false;
}

export function relocatedOptionSettingsForComponent(component, version) {
  if (!component || component.isGroup || component.isSubGroup) return [];
  const options = version?.gameConfig?.options || {};
  return SCENE_EDITOR_RELOCATED_OPTIONS.filter((entry) => {
    if (!componentMatchesRelocation(component, entry)) return false;
    return Object.prototype.hasOwnProperty.call(options, entry.optionKey);
  }).map((entry) => ({
    caption: entry.caption,
    path: entry.optionKey,
    editorType: entry.editorType,
    gameConfigPath: `gameConfig.options.${entry.optionKey}`,
  }));
}
